(() => {
  const bindSlideInert = (swiper) => {
    if (!swiper || typeof swiper.on !== 'function') return;

    const sync = () => {
      if (!swiper.slides) return;
      Array.from(swiper.slides).forEach((slide) => {
        const visible =
          typeof slide.isVisible === 'boolean'
            ? slide.isVisible
            : slide.classList.contains('swiper-slide-visible');
        if (visible) {
          slide.removeAttribute('inert');
        } else {
          slide.setAttribute('inert', '');
        }
      });
    };

    swiper.on('init', sync);
    swiper.on('afterInit', sync);
    swiper.on('slideChange', sync);
    swiper.on('transitionEnd', sync);
    swiper.on('resize', sync);
    swiper.on('breakpoint', sync);
    swiper.on('slidesUpdated', sync);
    sync();

    return sync;
  };

  if (typeof window.customElements.get('featured-collections') !== 'undefined') {
    return;
  }

  window.customElements.define(
    'featured-collections',
    class FeaturedCollections extends HTMLElement {
      constructor() {
        super();

        this.navItems = this.querySelectorAll('[data-featured-collections-nav-item]');
        this.collectionBlocks = this.querySelectorAll('[data-featured-collections-block]');
        this.carousels = this.querySelectorAll('[data-featured-collections-carousel]');
        this.swipers = [];

        this.initFeaturedCollections();
      }

      initFeaturedCollections() {
        try {
          this.setupNavigation();
          this.setupSwipers();
        } catch (error) {
          console.error('There was a problem with the FeaturedCollections component:', error);
        }
      }

      setupNavigation() {
        if (this.navItems.length < 1) {
          return;
        }

        this.navItems.forEach((navItem) => {
          navItem.addEventListener('click', () => {
            const blockId = navItem.getAttribute('data-featured-collections-nav-item');
            this.switchToBlock(blockId);
          });

          navItem.addEventListener('keydown', (e) => {
            const currentIndex = Array.from(this.navItems).indexOf(navItem);
            let targetIndex = currentIndex;

            switch (e.key) {
              case 'ArrowLeft':
                e.preventDefault();
                targetIndex = currentIndex > 0 ? currentIndex - 1 : this.navItems.length - 1;
                break;
              case 'ArrowRight':
                e.preventDefault();
                targetIndex = currentIndex < this.navItems.length - 1 ? currentIndex + 1 : 0;
                break;
              case 'Home':
                e.preventDefault();
                targetIndex = 0;
                break;
              case 'End':
                e.preventDefault();
                targetIndex = this.navItems.length - 1;
                break;
              default:
                return;
            }

            if (targetIndex !== currentIndex) {
              const targetBlockId = this.navItems[targetIndex].getAttribute('data-featured-collections-nav-item');
              this.switchToBlock(targetBlockId);
              this.navItems[targetIndex].focus();
            }
          });
        });
      }

      switchToBlock(blockId) {
        this.navItems.forEach((navItem) => {
          const isActive = navItem.getAttribute('data-featured-collections-nav-item') === blockId;
          navItem.classList.toggle('active', isActive);
          navItem.setAttribute('aria-selected', isActive ? 'true' : 'false');
          navItem.setAttribute('tabindex', '0');
        });

        this.collectionBlocks.forEach((block) => {
          const isActive = block.getAttribute('data-featured-collections-block') === blockId;
          block.classList.toggle('active', isActive);
          if (isActive) {
            block.removeAttribute('hidden');
          } else {
            block.setAttribute('hidden', '');
          }
        });

        requestAnimationFrame(() => {
          this.swipers.forEach(({ swiper, syncInert }) => {
            swiper.update();
            syncInert();
          });
        });
      }

      setupSwipers() {
        if (this.carousels.length < 1) {
          return;
        }

        this.carousels.forEach((carousel) => {
          const prevButton = carousel.querySelector('[data-featured-collections-carousel-prev]');
          const nextButton = carousel.querySelector('[data-featured-collections-carousel-next]');
          const swiperOptions = {
            slidesPerView: 'auto',
            spaceBetween: 10,
            centeredSlides: false,
            loop: false,
            rewind: true,
            watchSlidesProgress: true,
            a11y: { enabled: true },
            mousewheel: {
              enabled: true,
              forceToAxis: true,
            },
            navigation: {
              nextEl: nextButton,
              prevEl: prevButton,
            },
          };
          const collectionSwiper = new Swiper(carousel, swiperOptions);
          const syncInert = bindSlideInert(collectionSwiper);
          this.swipers.push({ swiper: collectionSwiper, syncInert });

          return collectionSwiper;
        });
      }
    }
  );
})();
